<div class="mt-2 ml-3 mr-3 pt-2">
  <div class="flex justify-content-between col-12 bg-white btn-with-links p-3">
    <label class="font-semibold uppercase category-name" translate>order.lbl_orders</label>
  </div>
  @if(data){
  <app-mi-table
    [collectionOfColumns]="allColumns"
    [attributeLabels]="attributeLabels"
    [data]="tableData"
    entityName="order"
    [isLoading]="isLoading"
    (onPageChange)="onPageChange($event)"
    (itemPerPageChange)="itemPerPageChange($event)"
    [totalRecords]="totalRecords"
    [itemsPerPage]="itemsPerPage"
    [message]="deleteSiteMsg"
    [header]="deleteSiteHeaderMsg"
    (onDelete)="onOrderDelete($event)"
    (onBulkDataDeleteEvent)="onBulkDataDeleteEvent($event)"
    (onRowSelection)="onRowSelect($event)"
    [filterList]="filterList"
    (onValueChange)="onFilterValueChange($event)"
    [filterFields]="filterFieldsArray"
    [label]="btnLabel"
    (onBtnClick)="onAdd()"
    [bulkUpdateLabel]="bulkUpdateLabel"
    [bulkDeleteLabel]="bulkDeleteLabel"
    [attributeData]="attributeData"
    (onBulkDataUpdateEvent)="onBulkDataUpdateEvent($event)"
    (onSearchValueChange)="onSearchValueChanges($event)"
    (onUpdate)="onUpdateOrder($event)"
    [rowItems]=""
    [bulkSelectionsItems]="bulkSelectionsItems"
    (setCurrentRowData)="setCurrentRowData($event)"
    [visiblePrintLabel]="visiblePrintLabel"
    [showBulkUpdateDialog]="showBulkUpdateDialog"
    (onToggleOverLay)="showBulkUpdateDialog = false; visiblePrintLabel = false"
    [visible]="visible"
    [bulkUpdateHeader]="bulkUpdateHeader"
    [reviewHeader]="reviewHeader"
    [btnUpdate]="btnUpdate"
    (onSortData)="onSortData($event)">
  </app-mi-table>
  }
</div>

@if(isSiteReady && showAddDialog) {
<p-dialog header="Add Order" [modal]="true" [(visible)]="showAddDialog" [style]="{ width: '60rem' }"
  (onHide)="onDialogClose()" (onShow)="onDialogShow()" (visibleChange)="onDialogVisibleChange($event)" [closable]="true"
  [closeOnEscape]="true">
  @if(showAddDialog) {
  <app-add-order
    #addOrder
    [protocolEntityId]="trialId"
    [orderId]="orderId"
    (saveSuccess)="onSaveSuccess()"
    [isChangeReasonNotRequired]="isChangeReasonNotRequired"
    [isEditNotAllowedSpecificStatus]="isEditNotAllowedSpecificStatus">
  </app-add-order>
  }
</p-dialog>
}